<script lang="ts">
  // Avatar aus dem Baukasten als SVG (Kopf, Haare, Bart, Mütze, Brille, Pullover).
  import { AV_BG, AV_HAIR, AV_SHIRT, AV_SKIN, type AvatarSpec } from '../../shared/avatar.ts';
  let { spec, size = 48, label = '' }: { spec: AvatarSpec | undefined; size?: number; label?: string } = $props();
  const a = $derived(spec ?? { skin: 1, hair: 1, hairColor: 1, beard: 0, hat: 0, glasses: 0, shirt: 0, bg: 0 });
  const hc = $derived(AV_HAIR[a.hairColor]);
</script>

<svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={label || 'Avatar'} class="av">
  <circle cx="50" cy="50" r="50" fill={AV_BG[a.bg]} />
  <!-- Pullover -->
  <path d="M14 100 C16 76 30 70 50 70 C70 70 84 76 86 100 Z" fill={AV_SHIRT[a.shirt]} />
  <path d="M40 71 L50 82 L60 71" fill="none" stroke="rgba(0,0,0,0.25)" stroke-width="3" />
  <!-- Hals, Kopf -->
  <rect x="43" y="58" width="14" height="14" rx="4" fill={AV_SKIN[a.skin]} />
  <ellipse cx="50" cy="44" rx="20" ry="23" fill={AV_SKIN[a.skin]} />
  <!-- Haare -->
  {#if a.hair === 1}
    <path d="M30 42 C29 22 71 22 70 42 C66 32 34 32 30 42 Z" fill={hc} />
  {:else if a.hair === 2}
    <path d="M28 50 C22 18 78 18 72 50 L70 38 C62 28 38 28 30 38 Z" fill={hc} />
  {:else if a.hair === 3}
    <path d="M28 64 C20 20 80 20 72 64 L68 40 C60 28 40 28 32 40 Z" fill={hc} />
  {:else if a.hair === 4}
    <circle cx="50" cy="22" r="9" fill={hc} />
    <path d="M30 40 C30 24 70 24 70 40 C64 30 36 30 30 40 Z" fill={hc} />
  {:else if a.hair === 5}
    <path d="M30 40 C34 20 66 20 70 40 L64 30 L58 36 L52 28 L46 36 L40 28 L34 36 Z" fill={hc} />
  {/if}
  <!-- Gesicht -->
  <circle cx="42" cy="46" r="2.6" fill="#16243a" />
  <circle cx="58" cy="46" r="2.6" fill="#16243a" />
  <ellipse cx="36" cy="53" rx="4" ry="2.4" fill="#bf5240" opacity="0.3" />
  <ellipse cx="64" cy="53" rx="4" ry="2.4" fill="#bf5240" opacity="0.3" />
  {#if a.beard === 1}
    <path d="M32 50 C32 72 68 72 68 50 C64 60 36 60 32 50 Z" fill={hc} />
  {:else if a.beard === 2}
    <path d="M40 56 C44 52 56 52 60 56 C56 55 44 55 40 56 Z" fill={hc} stroke={hc} stroke-width="3" />
  {:else if a.beard === 3}
    <path d="M44 60 C46 70 54 70 56 60 Z" fill={hc} />
  {/if}
  <path d="M44 58 Q50 62 56 58" fill="none" stroke="#5c3720" stroke-width="2" stroke-linecap="round" />
  {#if a.glasses === 1}
    <g fill="none" stroke="#16243a" stroke-width="2"><circle cx="42" cy="46" r="6" /><circle cx="58" cy="46" r="6" /><path d="M48 46 L52 46" /></g>
  {:else if a.glasses === 2}
    <g fill="#16243a" opacity="0.85"><rect x="34" y="41" width="14" height="9" rx="3" /><rect x="52" y="41" width="14" height="9" rx="3" /><rect x="47" y="44" width="6" height="2" /></g>
  {/if}
  <!-- Mütze -->
  {#if a.hat === 1}
    <path d="M28 36 C28 16 72 16 72 36 Z" fill="#bf5240" /><rect x="27" y="33" width="46" height="7" rx="3" fill="#8e2f25" />
  {:else if a.hat === 2}
    <path d="M30 32 C34 18 66 18 70 32 Z" fill="#16243a" /><rect x="24" y="30" width="52" height="6" rx="3" fill="#24395a" /><rect x="44" y="25" width="12" height="4" fill="#e0a346" />
  {:else if a.hat === 3}
    <path d="M26 36 C30 20 70 20 74 36 L80 38 L20 38 Z" fill="#3f5233" />
  {:else if a.hat === 4}
    <path d="M30 34 C32 22 68 22 70 34 Z" fill="#efe2c4" /><path d="M30 34 L70 34 L74 38 L26 38 Z" fill="#b08a3e" />
  {/if}
</svg>

<style>
  .av {
    flex: none;
    border-radius: 50%;
  }
</style>
